import { List, Tooltip } from 'antd';
import React, { useEffect } from 'react';
import { obterComentarioAnexoFormularioReqCompra } from '@app/api/demanda';
import { usePromise, Button, Icon } from '@digital/ui';
import { convertUTCtoLocal } from '@app/helpers/dateTimeFormats';
import moment from 'moment';

export default function ListMensagemAnexoFormularioReqCompra(props: any) {
  const { anexoId, recarregarMensagem } = props;

  const [getAllMensagem] = usePromise(
    () => (anexoId ? obterComentarioAnexoFormularioReqCompra(anexoId) : Promise.resolve(undefined)),
    [anexoId, recarregarMensagem],
    [],
  );

  return (
    <div>
      <List
        itemLayout="horizontal"
        dataSource={getAllMensagem}
        renderItem={item => (
          <List.Item>
            <List.Item.Meta
              title={
                <a href="#">
                  {item.nomeDoUsuario + ' - ' + convertUTCtoLocal(moment(item.dataHoraInclusao)).toLocaleString()}
                </a>
              }
              description={item.mensagem}
              className={item.isMrn ? 'classeMrn' : 'classeFornecedor'}
            />
          </List.Item>
        )}
      />
    </div>
  );
}
